<template>
    <div class="activity-type-flyer">
        <div class="flex-between" style="padding-top: 44px; position: relative; width: 320px; margin: 0 auto;">
            <el-form :model="form" :rules="rules" ref="form" class="demo-form">
                <div class="activity-modal-title" id="activityName">
                    <edit-input :className="'middle'" style="font-size: 17px;" :attrName="'activityName'"
                        @change="changeEditInput" v-model="form.activityName" placeholder="请填写活动名称" size="small" />
                </div>


                <div class="modal" :style="{ backgroundColor: '#1C80F0' }">
                    <img :src="templateData.mainImage" alt="" class="background-image" />


                    <edit-input :className="'middle'" :attrName="'activityTitle'" @change="changeEditInput"
                        id="activityTitle" :type="'TextArea'" v-model="form.activityTitle" placeholder="活动标题"
                        size="small" />

                    <div class="actions">
                        <div id="datePick" class="date-picker-wrapper" @click="openPicker">
                            <span class="date-picker-text">{{ formattedDate }}</span>
                            <img style="padding-left: 10px;" src="@/assets/images/schoolAbility/arrowDown.png" />
                            <!-- 隐藏的日期选择器 -->
                            <el-date-picker v-model="form.activityTime" type="daterange" value-format="yyyy-MM-dd"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions" ref="datePicker" class="hidden-date-picker" />
                        </div>
                        <div class="max-num-type">
                            <span style="width: 85px;" id="MaxNumType">本期名额：</span>
                            <el-radio-group style="padding-left:10px;" v-model="form.MaxNumType">
                                <el-radio style="color:#fff;font-size: 18px;" :label="1">不限制</el-radio>
                                <el-radio style="color:#fff;font-size: 18px;" :label="2">限制</el-radio>
                            </el-radio-group>
                            <el-input class="campus-operation-input" v-if="form.MaxNumType == 2"
                                controls-position="right" v-model="form.maxNum" placeholder="请输入人数" />
                        </div>
                    </div>

                    <div class="activity-price">
                        <div class="title-bg">
                            <img src="@/assets/images/schoolAbility/titleExplain.png" />
                        </div>
                        <div class="content">
                            <div class="operate"><edit-input class="my-edit" id="activityPrizeExplain"
                                    :attrName="'activityPrizeExplain'" @change="changeEditInput"
                                    v-model="form.activityPrizeExplain" :type="'TextArea'" :editBlack="true"
                                    placeholder="请填写活动说明" />

                                <div class="uploadBox">
                                    <div class="resourceFrame" v-if="form.activityPrizeImg">
                                        <el-image ref="previewImg" class="uploadSty" :src="form.activityPrizeImg"
                                            :preview-src-list="srcList" alt="" />
                                        <div class="hoverSty">
                                            <div class="item-preview" @click="deleteImg('activityPrizeImg')">
                                                <el-tooltip class="item" effect="light" content="删除图片"
                                                    placement="bottom-end">
                                                    <i class="el-icon-delete" size="16px"></i>
                                                </el-tooltip>
                                            </div>
                                            <div class="item-preview" @click="displace('activityPrizeImg')">
                                                <el-tooltip class="item" effect="light" content="替换图片"
                                                    placement="bottom-end">
                                                    <i class="el-icon-edit" size="16px"></i>
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else @click="displace('activityPrizeImg')">
                                        <div class="empty-img">
                                            <i class="el-icon-plus"></i>
                                            <div>点击添加图片</div>
                                            <div>支持jpg/png/gif格式, RGB模式，不超过5M</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="bottom-bg">
                            <img src="@/assets/images/schoolAbility/cardBottom.png" />
                        </div>
                    </div>
                    <div class="activity-rules">
                        <div class="title-bg">
                            <img src="@/assets/images/schoolAbility/titleRule.png" />
                        </div>
                        <div class="content">
                            <div class="operate">
                                <edit-input class="my-edit" id="activityRules" :attrName="'activityRules'"
                                    @change="changeEditInput" :type="'TextArea'" v-model="form.activityRules"
                                    placeholder="请填写活动规则" :editBlack="true" />

                                <div class="uploadBox">
                                    <div class="resourceFrame" v-if="form.activityRulesImg">
                                        <el-image ref="previewImg" class="uploadSty" :src="form.activityRulesImg"
                                            :preview-src-list="srcList" alt="" />
                                        <div class="hoverSty">
                                            <div class="item-preview" @click="deleteImg('activityRulesImg')">
                                                <el-tooltip class="item" effect="light" content="删除图片"
                                                    placement="bottom-end">
                                                    <i class="el-icon-delete" size="16px"></i>
                                                </el-tooltip>
                                            </div>
                                            <div class="item-preview" @click="displace('activityRulesImg')">
                                                <el-tooltip class="item" effect="light" content="替换图片"
                                                    placement="bottom-end">
                                                    <i class="el-icon-edit" size="16px"></i>
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else @click="displace('activityRulesImg')">
                                        <div class="empty-img">
                                            <i class="el-icon-plus"></i>
                                            <div>点击添加图片</div>
                                            <div>支持jpg/png/gif格式, RGB模式，不超过5M</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="bottom-bg">
                            <img src="@/assets/images/schoolAbility/cardBottom.png" />
                        </div>
                    </div>

                    <div class="agency-introduction">
                        <div class="title-bg">
                            <img src="@/assets/images/schoolAbility/titleIntro.png" />
                        </div>
                        <div class="content">
                            <div class="operate">
                                <edit-input id="agencyIntroduction" :attrName="'agencyIntroduction'" :type="'TextArea'"
                                    @change="changeEditInput" class="school-name-input my-edit" :editBlack="true"
                                    v-model="form.agencyIntroduction" placeholder="请填写机构介绍" size="small" />
                                <div class="uploadBox">
                                    <div class="resourceFrame" v-if="form.agencyIntroductionImg">
                                        <el-image ref="previewImg" class="uploadSty" :src="form.agencyIntroductionImg"
                                            :preview-src-list="srcList" alt="" />
                                        <div class="hoverSty">
                                            <div class="item-preview" @click="deleteImg('agencyIntroductionImg')">
                                                <el-tooltip class="item" effect="light" content="删除图片"
                                                    placement="bottom-end">
                                                    <i class="el-icon-delete" size="16px"></i>
                                                </el-tooltip>
                                            </div>
                                            <div class="item-preview" @click="displace('agencyIntroductionImg')">
                                                <el-tooltip class="item" effect="light" content="替换图片"
                                                    placement="bottom-end">
                                                    <i class="el-icon-edit" size="16px"></i>
                                                </el-tooltip>
                                            </div>
                                        </div>

                                    </div>
                                    <div v-else @click="displace('agencyIntroductionImg')">
                                        <div class="empty-img">
                                            <i size class="el-icon-plus"></i>
                                            <div>点击添加图片</div>
                                            <div>支持jpg/png/gif格式, RGB模式，不超过5M</div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <edit-input style="margin-top: 16px;" id="secAgencyIntroduction" class="my-edit"
                                    :attrName="'secAgencyIntroduction'" @change="changeEditInput"
                                    v-model="form.secAgencyIntroduction" :type="'TextArea'" :editBlack="true"
                                    placeholder="请填写机构介绍" />
                                <div class="uploadBox">
                                    <div class="resourceFrame" v-if="form.secAgencyIntroductionImg">
                                        <el-image ref="previewImg" class="uploadSty"
                                            :src="form.secAgencyIntroductionImg" :preview-src-list="srcList" alt="" />
                                        <div class="hoverSty">
                                            <div class="item-preview" @click="deleteImg('secAgencyIntroductionImg')">
                                                <el-tooltip class="item" effect="light" content="删除图片"
                                                    placement="bottom-end">
                                                    <i class="el-icon-delete" size="16px"></i>
                                                </el-tooltip>
                                            </div>
                                            <div class="item-preview" @click="displace('secAgencyIntroductionImg')">
                                                <el-tooltip class="item" effect="light" content="替换图片"
                                                    placement="bottom-end">
                                                    <i class="el-icon-edit" size="16px"></i>
                                                </el-tooltip>
                                            </div>
                                        </div>

                                    </div>
                                    <div v-else @click="displace('secAgencyIntroductionImg')">
                                        <div class="empty-img">
                                            <i size class="el-icon-plus"></i>
                                            <div>点击添加图片</div>
                                            <div>支持jpg/png/gif格式, RGB模式，不超过5M</div>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <div class="bottom-bg">
                            <img src="@/assets/images/schoolAbility/cardBottom.png" />
                        </div>
                    </div>
                    <div class="agency-contact">
                        <div class="title-bg">
                            <img src="@/assets/images/schoolAbility/contactWay.png" />
                        </div>
                        <div class="content">
                            <div class="operate">
                                <span class="label-name" id="agencyContact">联系电话：</span><edit-input
                                    :attrName="'agencyContact'" @change="changeEditInput" class="agency-address my-edit"
                                    v-model="form.agencyContact" :editBlack="true" placeholder="请填写联系电话" size="small" />
                                <span class="label-name" id="agencyAddress">联系地址：</span><edit-input
                                    :attrName="'agencyAddress'" @change="changeEditInput" class="agency-address my-edit"
                                    v-model="form.agencyAddress" :editBlack="true" type="textarea"
                                    placeholder="请填写联系地址" />
                                <div class="qrcode-box" id="ewmImg">
                                    <div class="uploadBox">
                                        <div class="resourceFrame" v-if="form.ewmImg">
                                            <el-image ref="previewImg" class="uploadSty qr-uploadSty" :src="form.ewmImg"
                                                :preview-src-list="srcList" alt="" />
                                            <div class="hoverSty">
                                                <div class="item-preview" @click="deleteImg('ewmImg')">
                                                    <el-tooltip class="item" effect="light" content="删除图片"
                                                        placement="bottom-end">
                                                        <i class="el-icon-delete" size="16px"></i>
                                                    </el-tooltip>
                                                </div>
                                                <div class="item-preview" @click="displace('ewmImg')">
                                                    <el-tooltip class="item" effect="light" content="替换图片"
                                                        placement="bottom-end">
                                                        <i class="el-icon-edit" size="16px"></i>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else @click="displace('ewmImg')">
                                            <div class="empty-img last-empty-img">
                                                <i size class="el-icon-plus"></i>
                                                <div>点击上传二维码</div>
                                            </div>
                                        </div>
                                    </div>
                                    <span class="qrcode-txt">扫码关注公众号</span>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-bg">
                            <img src="@/assets/images/schoolAbility/cardBottom.png" />
                        </div>
                    </div>
                    <div class="other-settings">
                        <div class="title-bg" :style="{ backgroundImage: 'url(' + templateData.prizeTitlePic + ')' }">
                            其他设置
                        </div>
                        <el-form-item id="principal" label="活动跟进人：" prop="principal">
                            <el-select v-model="form.principal" placeholder="请选择活动跟进人" style="width: 100%" clearable>
                                <el-option v-for="(item, index) in personnel" :key="index" :label="item.userName"
                                    :value="item.userId" />
                            </el-select>
                        </el-form-item>

                        <!-- <el-form-item label="背景音乐：" style="margin-bottom: 10px"> -->
                        <!--   <el-select v-model="form.bgMusic" placeholder="请选择背景音乐" style="width: 100%" clearable> -->
                        <!--     <el-option v-for="(item, index) in musicChooseList" :key="index" :label="item.musicName" :value="item.musicAddress" /> -->
                        <!--   </el-select> -->
                        <!-- </el-form-item> -->

                        <el-form-item id="managerInfo" label="报名信息设置（多选）：" style="margin-bottom: 10px"
                            prop="managerInfo">
                            <br>
                            <el-checkbox-group v-model="form.managerInfo" size="small">
                                <el-checkbox v-for="item in managerInfoList" :key="item.name" :label="item.name"
                                    :disabled="item.isRequired === 1" style="margin-left: 8px" size="small">
                                    {{ item.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>

                        <el-form-item id="applySuccessMsg" label="报名成功提醒：" prop="applySuccessMsg">
                            <el-input type="textarea" v-model="form.applySuccessMsg" rows="3" maxlength="36" />
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <div class="bottom-btn">
                <img src="@/assets/images/schoolAbility/button.png" />
            </div>
        </div>
        <el-upload action="#" :on-change="handleFileChange" list-type="picture-card" accept="image/*" name="file"
            :show-file-list="false" ref="upload" :limit="1" style="display: none" :auto-upload="false">
        </el-upload>
    </div>
</template>

<script>
import { getBaseUrl } from "@/util/config";
import LoginUserHelper from "@/util/LoginUserHelper";
import axios from "axios";
import { getSubUsers } from "@/api/AccountSetting";
import EditInput from "./EditInput.vue";
import { isContainSensitiveWord, createOrUpdateActivity } from "@/api/SchoolAbility";
import { throttle } from "@/util/throttle";

export default {
    name: 'edit-activity',
    components: {
        EditInput,
    },
    data() {
        return {
            // UpLoadUrl: `${getBaseUrl()}base/upload/uploadPicture`, // 图片上传接口
            templateData: {
                backgroundColor: '',
                buttonPic: '',
                prizeTitlePic: '',
                backgroundImage: '',
                mainImage: ''
            },
            form: {
                mainImage: '',
                activityName: '',
                activityTitle: '',
                activityPrizeExplain: '',
                activityPrizeImg: '',
                activityRules: '',
                activityRulesImg: '',
                agencyIntroduction: '',
                secAgencyIntroduction: '',
                agencyIntroductionImg: '',
                secAgencyIntroductionImg: '',
                agencyName: '',
                MaxNumType: 1,
                maxNum: '',
                activityStartTime: '',
                activityEndTime: '',
                managerInfo: [],
                activityTime: [],
                principal: 0,
                applySuccessMsg: '3天内将会有工作人员联系您，请保持手机畅通！',
                secAgencyIntroductionImg: '',
                ewmImg: '',
            },
            activityPrizeImgOption: [],
            agencyIntroductionImgOption: [],
            today: new Date(), // 今天的日期
            imgPath: "", // 当前上传图片位置
            fileList: [], // 上传图片
            srcList: [], // 预览图片
            personnel: [],
            musicChooseList: [],
            managerInfoList: [],
            rules: {
                activityName: [
                    { required: true, message: "请输入活动名称", trigger: "blur" },
                ],
                activityPrizeExplain: [
                    { required: true, message: "请输入活动奖品", trigger: "blur" },
                ],
                activityRules: [
                    { required: true, message: "请输入活动规则", trigger: "blur" },
                ],
                activityTitle: [
                    { required: true, message: "请输入活动标签", trigger: "blur" },
                ],
                agencyAddress: [
                    { required: true, message: "请输入机构地址", trigger: "blur" },
                ],
                agencyContact: [
                    { required: true, message: "请输入机构联系人", trigger: "blur" },
                ],
                agencyIntroduction: [
                    { required: true, message: "请输入机构简介", trigger: "blur" },
                ],
                agencyName: [
                    { required: true, message: "请输入机构名称", trigger: "blur" },
                ],
                managerInfo: [
                    { required: true, message: "请输入报名信息", trigger: "blur" },
                ],
                activityEndTime: [
                    { required: true, message: "请选择活动结束时间", trigger: "change" },
                ],
                activityStartTime: [
                    { required: true, message: "请选择活动开始时间", trigger: "change" },
                ],
                agencyEwm: [
                    { required: true, message: "请输入机二维码介绍", trigger: "blur" },
                ],
                principal: [
                    { required: true, message: "请选择负责人", trigger: "change" },
                ],
                applySuccessMsg: [
                    { required: true, message: "请输入报名成功提示语", trigger: "blur" },
                ],
            },
            pickerOptions: {
                disabledDate: this.disabledDate, // 禁用日期逻辑
            },
        };
    },

    props: {
        templateInfo: {
            type: Object,
            default: () => ({})
        },
        agencyInfo: {
            type: Object,
            default: () => ({})
        },
        activityInfo: {
            type: Object,
            default: () => ({})
        },
        activityConfig: {
            type: Object,
            default: () => ({})
        },
    },
    computed: {
        formattedDate() {
            return this.form.activityTime.length ? `${this.form.activityTime[0].split('-').join('.')} ~ ${this.form.activityTime[1].split('-').join('.')}` : '请选择活动开始结束时间';
        }
    },
    methods: {
        disabledDate(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // 将时间归零
            return date < today; // 禁用今天之前的日期
        },
        deleteImg(imgType) {
            this.form[imgType] = '';
        },
        // 唤起上传
        displace(url) {
            this.imgPath = url;
            // 触发文件选择对话框
            this.$refs.upload.clearFiles();
            this.$refs.upload.$el.querySelector('input[type="file"]').click();
        },
        handleFileChange(item, fileList) {
            let fileRaw = item.raw;
            let fileType = ["image/jpeg", "image/png", "image/gif"];
            //限制图片 格式、size、

            if (!fileType.includes(fileRaw.type)) {
                this.$message.error("图片只能是 JPG/PNG/GIF 格式!");

                const index = fileList.findIndex((f) => f.url === item.url);
                const newFileList = fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
                // this.fileLength--;
                return;
            }
            const isLt5M = item.size / 1024 / 1024 < 5;
            if (!isLt5M) {
                this.$refs.upload.clearFiles();

                this.$message.error("图片大于5M，请压缩后上传!");

                const index = fileList.findIndex((f) => f.url === item.url);
                const newFileList = fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
                return false;
            }
            let FormDatas = new FormData();
            FormDatas.append("file", item.raw);
            let BASE_URL = getBaseUrl();
            axios
                .post(`${BASE_URL}base/upload/uploadPicture?type=record`, FormDatas, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        authorization: LoginUserHelper.getUserToken(),
                    },
                })
                .then((res) => {
                    if (res.code == 0) {
                        this.$refs.form.clearValidate();
                        let { fileName, uploadPath } = res.data;

                        this.fileList.push({
                            url: uploadPath,
                        });
                        console.log(uploadPath, "uploadPath",this.imgPath,this.form[this.imgPath]);
                        
                        if (
                            this.imgPath === "mainPic" ||
                            this.imgPath === "backgroundPic"
                        ) {
                            this.form[this.imgPath] = [{ url: uploadPath }];
                        } else {
                            this.form[this.imgPath] = uploadPath;
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },
        async getActivityConfig() {
            const ret = await getSubUsers()
            if (ret.code === 0) {
                this.personnel = ret.data;
            }
            else {
                this.$message(ret.message)
            }
            const { managerInfo, principal, copyWriteDtoList } = this.activityConfig;
            // const managerInfoList = JSON.parse("[{\"name\":\"姓名\",\"field\":\"name\",\"select\":1,\"isRequired\":1},{\"name\":\"性别\",\"field\":\"sex\",\"select\":0,\"isRequired\":0},{\"name\":\"出生年月\",\"field\":\"birthday\",\"select\":0,\"isRequired\":0},{\"name\":\"年龄\",\"field\":\"age\",\"select\":0,\"isRequired\":0},{\"name\":\"年级\",\"field\":\"grade\",\"select\":0,\"isRequired\":0},{\"name\":\"在读学校\",\"field\":\"school\",\"select\":0,\"isRequired\":0}]");
            const managerInfoList = JSON.parse(managerInfo || '[]');
            const managerInfoVal = [];
            let applySuccessMsg = '';
            if (copyWriteDtoList)
                copyWriteDtoList.forEach((item) => {
                    if (item.copyWriteType === 8113001) {
                        applySuccessMsg = item.copyWriteContent;
                    }
                });
            if (managerInfoList)
                managerInfoList.forEach((item) => {
                    if (item.select === 1) {
                        managerInfoVal.push(item.name);
                    }

                });

            this.managerInfoList = managerInfoList;
            this.$nextTick(() => {
                this.form = {
                    ...this.form,
                    managerInfo: managerInfoVal,
                    principal: principal === null ? this.personnel[0].userId : principal,
                    applySuccessMsg,
                };
            })

        },
        getAgencyInfo() {// 校区默认信息
            let {
                agencyContact,
                agencyIntroduction,
                agencyAddress,
                agencyName,
                managerInfo,
                agencyFiles,
                agencyEwm
            } = this.agencyInfo

            let activityRulesImg, activityPrizeImg, agencyIntroductionImg, agencyIntroductionVideo, ewmImg, secAgencyIntroductionImg
            (agencyFiles || []).forEach((item) => {
                if (item.fileModule === 8004011) {
                    activityPrizeImg = item.fileUrl
                }
                else if (item.fileModule === 8004012) {
                    activityRulesImg = item.fileUrl
                }
                else if (item.fileModule === 8004013) {
                    if (item.fileType === 0) {
                        agencyIntroductionImg = item.fileUrl
                    } else if (item.fileType === 1) {
                        agencyIntroductionVideo = item.fileUrl
                    }
                } else if (item.fileModule === 8004014) {
                    secAgencyIntroductionImg = item.fileUrl
                }
                else if (item.fileModule === 8004015) {
                    ewmImg = item.fileUrl
                }
            })
            this.form = {
                ...this.form,
                activityRulesImg,
                activityPrizeImg,
                agencyContact: agencyContact || '',
                agencyIntroduction: agencyIntroduction.split('-$songshu$-')[0] || '',
                secAgencyIntroduction: agencyIntroduction.split('-$songshu$-')[1] || '',
                agencyAddress: agencyAddress || '',
                agencyName: agencyName || '',
                managerInfo: JSON.parse(managerInfo || '[]'),
                agencyEwm,
                ewmImg,
                agencyIntroductionImg,
                secAgencyIntroductionImg,
                agencyIntroductionVideo,
            }
        },
        getActivityInfo() {
            let {
                activityEndTime,
                activityFiles,
                activityName,
                activityRules,
                activityPrizeExplain,
                activityStartTime,
                activityTitle,
                agencyAddress,
                agencyContact,
                agencyIntroduction,
                agencyName,
                agencyEwm,
                maxNum,
                activityNo,
            } = this.activityInfo
            let activityRulesImg, activityPrizeImg, ewmImg, agencyIntroductionImg, agencyIntroductionVideo, secAgencyIntroductionImg
            (activityFiles || []).forEach(item => {
                if (item.fileModule === 8004011) {
                    activityPrizeImg = item.fileUrl
                } else if (item.fileModule === 8004012) {
                    activityRulesImg = item.fileUrl
                } else if (item.fileModule === 8004013) {
                    if (item.fileType === 0) {
                        agencyIntroductionImg = item.fileUrl
                    } else if (item.fileType === 1) {
                        agencyIntroductionVideo = item.fileUrl
                    }
                } else if (item.fileModule === 8004014) {
                    secAgencyIntroductionImg = item.fileUrl
                }
                else if (item.fileModule === 8004015) {
                    ewmImg = item.fileUrl
                }
            })
            this.form = {
                ...this.form,
                activityNo,
                MaxNumType: maxNum && (maxNum > 0) ? 2 : 1,
                maxNum,
                activityName,
                activityRulesImg,
                activityTitle,
                activityPrizeExplain,
                activityPrizeImg,
                secAgencyIntroductionImg,
                activityRules,
                agencyIntroduction: agencyIntroduction.split('-$songshu$-')[0] || '',
                secAgencyIntroduction: agencyIntroduction.split('-$songshu$-')[1] || '',
                agencyIntroductionImg,
                agencyIntroductionVideo,
                agencyContact,
                agencyAddress,
                agencyEwm,
                ewmImg,
                agencyName,
                activityTime: activityEndTime ? [activityStartTime.split(' ')[0], activityEndTime.split(' ')[0]] : [],
            }
        },
        getTemplateInfo() {
            let {
                backgroundColor,
                buttonPic,
                prizeTitlePic,
                backgroundPic,
                templateName,
                mainPic
            } = this.templateInfo
            this.form = {
                ...this.form,
                activityName: templateName
            }
            this.templateData = {
                backgroundColor,
                buttonPic,
                prizeTitlePic,
                backgroundImage: backgroundPic && backgroundPic[0] ? backgroundPic[0].url || '' : '',
                mainImage: mainPic && mainPic[0] && mainPic[0].url,
            }
        },

        // 新增编辑
        addActivity: throttle(async function () {
            if (!this.form.activityName) {
                this.scrollToElement('activityName')
                this.$message.warning('请填写活动名称')
            }
            else if (!this.form.activityTitle) {
                this.scrollToElement('activityTitle')
                this.$message.warning('请填写活动标题')
            }
            else if (!this.form.activityTime.length) {
                this.scrollToElement('datePick')
                this.$message.warning('请选择开始结束时间')
            }
            else if (!this.form.MaxNumType) {
                this.scrollToElement('MaxNumType')
                this.$message.warning('请选择本期名额')
            }
            else if (!this.form.activityPrizeExplain) {
                this.scrollToElement('activityPrizeExplain')
                this.$message.warning('请填写活动说明')
            }
            else if (!this.form.activityRules) {
                this.scrollToElement('activityRules')
                this.$message.warning('请填写活动规则')
            }
            else if (!this.form.agencyIntroduction) {
                this.scrollToElement('agencyIntroduction')
                this.$message.warning('请填写机构介绍')
            }
            else if (!this.form.agencyContact) {
                this.scrollToElement('agencyContact')
                this.$message.warning('请填写机构联系电话')
            }
            else if (!this.form.agencyAddress) {
                this.scrollToElement('agencyAddress')
                this.$message.warning('请填写机构联系地址')
            }
            // else if (!this.form.ewmImg) {
            //     this.scrollToElement('ewmImg')
            //     this.$message.warning('请上传二维码图片')
            // }
            else if (!this.form.principal) {
                this.scrollToElement('principal')
                this.$message.warning('请选择活动跟进人')
            }
            else if (!this.form.managerInfo) {
                this.scrollToElement('managerInfo')
                this.$message.warning('请选择报名信息设置')
            }
            else if (!this.form.applySuccessMsg) {
                this.scrollToElement('applySuccessMsg')
                this.$message.warning('请输入报名成功提醒')
            }
            else {
                let activityFiles = []
                if (this.form.activityPrizeImg) {
                    activityFiles.push({
                        fileModule: 8004011,
                        fileType: 0,
                        fileUrl: this.form.activityPrizeImg || '',
                        fileName: '活动说明图片',
                        sort: 1,
                    })
                }
                if (this.form.activityRulesImg) {
                    activityFiles.push({
                        fileModule: 8004012,
                        fileType: 0,
                        fileUrl: this.form.activityRulesImg || '',
                        fileName: '活动规则图片',
                        sort: 1,
                    })
                }
                if (this.form.agencyIntroductionImg) {
                    activityFiles.push({
                        fileModule: 8004013,
                        fileType: 0,
                        fileUrl: this.form.agencyIntroductionImg || '',
                        fileName: '机构介绍图片',
                        sort: 1,
                    })
                }
                if (this.form.secAgencyIntroductionImg) {
                    activityFiles.push({
                        fileModule: 8004014,
                        fileType: 0,
                        fileUrl: this.form.secAgencyIntroductionImg || '',
                        fileName: '机构介绍图片2',
                        sort: 1,
                    })
                }
                if (this.form.ewmImg) {
                    activityFiles.push({
                        fileModule: 8004015,
                        fileType: 0,
                        fileUrl: this.form.ewmImg || '',
                        fileName: '二维码图片',
                        sort: 1,
                    })
                }
                const { templateType, templateNo } = this.templateInfo
                let managerInfoJson = this.managerInfoList.map((item, index) => {
                    return {
                        ...item,
                        select: this.form.managerInfo.indexOf(item.name) >= 0 ? 1 : 0
                    }
                })
                if (this.form.MaxNumType === 1) {
                    this.form.maxNum = 0
                }
                const params = {
                    ...this.form,
                    activityStartTime: this.form.activityTime[0],
                    activityEndTime: this.form.activityTime[1],
                    activityFiles,
                    activityType: templateType,
                    templateNo,
                    defaultApplyNum: 0,
                    // agencyIntroduction: `${this.form.agencyIntroduction}-$songshu$-${this.form.secAgencyIntroduction}`,
                    agencyIntroduction: `${this.form.agencyIntroduction}`,
                    defaultViewNum: 0,
                    agencyLat: '',
                    managerInfo: JSON.stringify(managerInfoJson),
                    agencyLng: '',
                };
                const isContained = await isContainSensitiveWord({ content: JSON.stringify(params) })

                if (isContained.code == 0) {
                    if (isContained.data) {
                        this.$confirm('活动设置中存在敏感词汇，确认发布将被强制转换，是否继续发布', '敏感词检测', {
                            confirmButtonText: '继续发布',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.$emit("activityUpdate", params);
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消创建'
                            });
                        });
                    }
                    else {
                        this.$emit("activityUpdate", params);
                    }
                }
            }
        }),
        scrollToElement(id) {
            // 使用 scrollIntoView 滚动到目标元素
            document.getElementById(id).scrollIntoView({
                behavior: 'smooth', // 平滑滚动
                block: 'start', // 元素对齐方式，'start' 对齐到顶部
            });
        },
        changeEditInput(val, attr) {
            this.form[attr] = val
        },
        openPicker() {
            // 手动唤起日期选择器
            this.$refs.datePicker.showPicker();
        },
    },
    created() {
        if (Object.keys(this.templateInfo).length) this.getTemplateInfo()
        if (Object.keys(this.activityConfig).length) this.getActivityConfig()
        if (Object.keys(this.agencyInfo).length) this.getAgencyInfo()
        if (Object.keys(this.activityInfo).length) this.getActivityInfo()

    },
};
</script>

<style lang="scss" scoped>
/* Add your custom styles here */
.activity-type-flyer .modal {
    background-color: #fff;
}

.activity-price,
.activity-rules,
.agency-introduction,
.agency-contact {
    width: 335px;
    border-radius: 20px;
    margin: 30px auto 0 auto;



    .content {
        background: #3CA1FF;
        padding: 0 0 0 16px;
        border: 1px solid;
        border-color: rgba(88, 219, 255, 1);
        border-top: none;
        border-bottom: none;

        .operate {
            color: #999999;
            font-size: 16px;
            width: 301px;
            background: #fff;

            .my-edit {
                padding-left: 16px;
                padding-bottom: 16px;
            }

            .uploadBox {
                padding: 0 16px 0 16px;

                .uploadSty,
                .resourceFrame {
                    width: 100%;
                    background-color: #fbfdff;
                    font-size: 44px;
                    color: #8c939d;
                    border-radius: 6px;
                    box-sizing: border-box;
                    cursor: pointer;
                    font-weight: 200;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    object-fit: contain;
                    flex-shrink: 0;


                }

                .qr-uploadSty {
                    max-height: 144px;
                }

                .hoverTxt {
                    color: #93caf6;
                    font-size: 16px;
                    font-weight: 600;
                    cursor: pointer;
                }

                .uploadSty:hover {
                    border-color: #0055e9;
                }

                .resourceFrame {
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .hoverSty {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    top: 0;
                    left: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                    opacity: 0;
                    transition: opacity 0.3s;
                    box-sizing: border-box;
                }

                .el-icon-zoom-in,
                .el-icon-delete,
                .el-icon-edit {
                    font-size: 20px;
                    font-weight: 600;
                    color: #fff;
                    line-height: 20px;
                }

                .resourceFrame:hover .hoverSty {
                    opacity: 1;
                }
            }
        }
    }

    .title-bg,
    .bottom-bg {
        margin-bottom: -4px;

        img {
            width: 100%;
            display: block;
        }
    }
}

.selection-img {
    width: 100px;
    height: 100px;
}

.activity-type-flyer {
    .cursor-move {
        cursor: move;
    }

    margin-left: auto;
    margin-right: auto;
    width:60%;
    align-items: flex-start;
    position: relative;

    .activity-modal-title {
        color: #fff;
        width: 375px;
        top: 0px;
        left: 0px;
        line-height: 44px;
        background: linear-gradient(135deg, #1B94FF 0%, #23B0FF 100%);
        position: absolute;
        z-index: 999;
    }

    .modal {
        max-height: calc(100vh - 350px);
        width: 373px;
        border: 1px solid #ccc;
        background: 50% 0px no-repeat;
        background-size: 100% auto;
        padding-bottom: 15px;
        overflow-y: auto;
        overflow-x: hidden;

        #activityTitle {
            margin: 50px 15px 50px 15px;
            color: #fff;
            font-size: 32px;
            font-weight: bold;
        }

        ::v-deep #activityTitle .textareaContent {
            display: block;
            text-align: center;
        }

        .background-image {
            display: block;
            width: 100%;
        }

        .activity-prize-img-box {
            position: relative;

            .icon {
                cursor: pointer;
                display: none;
                position: absolute;
                background: rgba(0, 0, 0, 0.5);
                color: #fff;
                width: 24px;
                height: 24px;
                top: 7px;
                right: 7px;
                border-radius: 5px;
                font-size: 12px;
                line-height: 27px;

                &:last-child {
                    right: 40px;
                }
            }

            &:hover {
                .icon {
                    display: block;
                }
            }
        }

        /* 背景裁剪到边框 */
        .actions::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: 20px;
            /* 确保圆角一致 */
            padding: 1px;
            /* 边框宽度 */
            background: linear-gradient(180deg, rgba(182, 236, 229, 1), rgba(91, 225, 251, 1));
            /* 渐变颜色 */
            -webkit-mask: linear-gradient(#ffffff 0 0) content-box, linear-gradient(#fff 0 0);
            -webkit-mask-composite: destination-out;
            mask-composite: exclude;
        }

        .actions {
            position: relative;
            width: 321px;
            background: linear-gradient(180deg, #2850E6 0%, #1987F1 100%);
            border-radius: 20px;
            border: 1px solid;
            margin: 20px auto 0;
            padding: 23px 0 13px 0;
            color: #ffffff;

            .date-picker-wrapper {
                position: absolute;
                top: -30px;
                left: 50%;
                transform: translate(-50%);
                display: inline-flex;
                align-items: center;
                justify-content: center;
                border-radius: 16px;
                z-index: 99;
                background: linear-gradient(180deg, #2850E6 0%, #1987F1 100%);
                color: #fff;
                font-size: 18px;
                text-align: center;
                cursor: pointer;
                line-height: 41px;
                width: 269px;
                height: 51px;
                /* 设置渐变作为边框 */
                border-image-slice: 1;
                /* 定义边框图片的裁剪方式 */
                /* 渐变背景 */
                background-clip: border-box;



                span {
                    border-radius: 12px;
                    display: block;
                }

                /* 隐藏默认日期选择器 */
                .hidden-date-picker {
                    position: absolute;
                    visibility: hidden !important;
                }
            }

            /* 背景裁剪到边框 */
            .date-picker-wrapper::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                border-radius: 16px;
                /* 确保圆角一致 */
                padding: 5px;
                /* 边框宽度 */
                background: linear-gradient(to bottom, rgba(182, 236, 229, 1), rgba(91, 225, 251, 1));
                /* 渐变颜色 */
                -webkit-mask: linear-gradient(#ffffff 0 0) content-box, linear-gradient(#fff 0 0);
                -webkit-mask-composite: destination-out;
                mask-composite: exclude;
                z-index: 99;
            }

            .actions-start-time,
            .actions-end-time {
                padding: 8px;
                font-size: 12px;
            }

            .max-num-type {
                z-index: 999;
                padding: 15px 0 5px 38px;
                font-size: 18px;

                &>div {
                    .radio-item {
                        color: #fff;
                    }
                }

                ::v-deep .el-radio__label {
                    font-size: 18px;
                    color: #fff;
                }

            }

            .count-down {
                font-size: 12px;
                text-align: center;

                span {
                    display: inline-block;
                    padding: 3px 5px;
                    background-image: linear-gradient(-180deg, #DEF3FF 0%, #BAE2FE 100%);
                    border-radius: 4px;
                    font-family: SourceHanSansCN-Bold;
                    font-size: 12px;
                    color: #4C4C4C;
                    letter-spacing: 0;
                    text-align: center;
                }
            }

            .btn {
                width: 60%;
                height: 60px;
                line-height: 60px;
                background: 50% 50% no-repeat;
                background-size: 100% 100%;
                font-family: SourceHanSansCN-Bold;
                font-size: 18px;
                color: #453500;
                letter-spacing: 0;
                text-align: center;
                margin: 20px auto 0;
            }
        }

        .selection {
            background: #FFFFFF;
            border-radius: 20px;
            width: 90%;
            margin: 40px auto 0;
            padding: 0 15px 15px;
        }

        .empty-img {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 100%;
            height: 161px;
            cursor: pointer;
            border: 1px solid #E6E6E6;
            border-radius: 12px;

            .el-icon-plus {
                font-size: 30px;
                color: #58ABF6
            }

            div:nth-child(2) {
                font-family: SourceHanSansCN-Normal;
                font-size: 14px;
                color: #58ABF6;
                margin: 15px 0 3px;
            }

            div:nth-child(3) {
                opacity: 0.5;
                font-family: SourceHanSansCN-Normal;
                font-size: 12px;
                color: #CCCCCC;
                text-align: center;
            }
        }

        .last-empty-img {
            height: 135px;
            font-size: 14px;
            border: none;
            background: #F6F9FD;
        }

        .selection-img {
            display: block;
            width: 100%;
            margin: 10px 0;
        }

        .agency-contact {

            .agency-address {
                padding-left: 0px;
                display: inline-block;
                width: 180px;
                font-size: 15px;
                letter-spacing: 0;
            }

            .label-name {
                color: #323232;
                width: 80px;
                display: inline-block;
                padding-left: 16px;
            }

            .qrcode-box {
                padding-top: 20px;


                .uploadBox {
                    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
                    width: 136px;
                    margin: 0 auto;
                    padding: 8px;
                    height: 136px;
                    border-radius: 12px;
                }
            }

            .qrcode-txt {
                font-size: 16px;
                color: #323232;
                display: block;
                text-align: center;
                line-height: 50px;
                height: 40px;
            }
        }
    }

    .el-icon-picture {
        color: #4A83E8;
        font-size: 40px;
    }

    .other-settings {
        background: #fff;
        width: 80%;
        border-radius: 20px;
        margin: 40px auto 0 auto;
        padding: 0 15px 15px 15px;

        .title-bg {
            background: 50% 50% no-repeat;
            background-size: 100% 100%;
            width: 147px;
            height: 48px;
            line-height: 48px;
            margin: 0 auto 0;
            font-family: SourceHanSansCN-Bold;
            font-size: 18px;
            color: #453500;
            letter-spacing: 0;
            text-align: center;
            position: relative;
            top: -24px;
        }
    }

    .bottom-btn {
        width: 375px;
        height: 84px;
        background: #008FFF;

        img {
            display: block;
            padding-top: 12px;
            width: 224px;
            margin-left: auto;
            margin-right: auto;
        }
    }
}

::v-deep input[aria-hidden="true"] {
    display: none !important;
}

::v-deep.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
}
</style>
<style>
.campus-operation-input .el-input__inner {
    margin-left: 99px;
    margin-top: 10px;
    width: 150px;
    font-size: 16px;
    background: none;
    height: 34px;
    border-radius: 4px;
    border: 1px solid #58ABF6;
    color: #fff;
}
</style>